<template>
    <div class="rodemap">
        <div class="mask05"></div>
        <QuestionSelect :data="data" @jump="jump" @finish="finish"></QuestionSelect>
    </div>
</template>

<script>
    //script
    import Tools from '../../../scripts/tools';
    import {gsap} from 'gsap';
    //Global
    import Global from '../../../scripts/Global';

    import QuestionSelect from '../../cmp/questionSelect';

    export default {
        data() {
            return {
                data: {
                    headTipImg: 'cv-03',
                    headTipTxt: '笨！我帮你！',

                    qText: '移动哪一个元素能获得太平花呢？',
                    qImg: '太平花',

                    errText: '移动那一个元素能获得太平花呢？',
                    okText: '移动那一个元素能获得太平花呢？',
                    headTipStyle: {
                        bottom: '-1rem',
                    },
                    answerArr: [
                        {
                            txt: '葡 萄',
                        },
                        {
                            txt: '梨 子',
                        },
                        {
                            txt: '苹 果',
                            right: true,
                        },
                    ],
                },
            };
        },
        components: {
            QuestionSelect,
        },
        created() {
        },
        computed: {},
        methods: {
            jump(event) {
                if (event) {
                } else {
                    this.$router.replace('/rodemap/aj/03');
                }
                console.log(event, 'event');
            },
            finish(event) {
                let self = this;
                Global.curr = {
                    ...this.data,
                    headTipImg: 'cv-03',
                    headTipTxt: '嗯，这个给你，刚刚偷偷藏下的一枝，走吧。',
                    headTipPath: '/rodemap/aj/03',
                    headTipPathTxt: '前往天一门 >>',
                    ybtxt: '多谢啦，这个给你们',
                    bg: '坤宁门',
                    textCfg: {
                        'text-align': 'center',
                    },
                    headTipStyle: {
                        bottom: '-1rem',
                    },
                    flower: 1,
                };
                Global.yubi.aj.b1 = true;
                if (event) {
                    this.$router.replace('/yu');
                    Global.startPlay('aj', 'scene4');
                } else {
                    Global.startPlay('aj', 'scene3');
                    setTimeout(function () {
                        self.$router.replace('/yu');
                        Global.curr.headTipImg = 'cv-03'
                        Global.curr.headTipTxt = '嗯，这个给你，刚刚偷偷藏下的一枝，走吧。'
                        Global.startPlay('aj', 'scene4');
                    }, 3000)
                }
            },
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .rodemap {
        background-image: url(//cdn.original-fun.com/gugong/坤宁门.jpg);
        background-position: center;
        width: 100vw;
        height: 100vh;
        max-width: 75vh;
        margin: 0 auto;
        overflow: hidden;
        background-size: cover;
        background-repeat: no-repeat;
    }
</style>
